export default "__VITE_ASSET__Du6nsW0F__"